import { FieldProps } from 'formik';
import {
  Input,
  Textarea,
  Text,
  Box,
} from '@chakra-ui/react';

interface VTOTextFieldProps extends FieldProps {
  placeholder?: string;
  isEditing: boolean;
  rows?: number;
  notDefinedText?: string;
}

/**
 * Formik-aware text field component for VTO
 * Renders as Input (rows=1) or Textarea (rows>1) when editing
 * Renders as Text when not editing
 */
export function VTOTextField({
  field,
  form,
  placeholder = '',
  isEditing,
  rows = 3,
  notDefinedText = 'Not defined',
}: VTOTextFieldProps) {
  const value = field.value || '';
  const error = form.errors[field.name];

  if (!isEditing) {
    if (!value) {
      return (
        <Text as="span" color="gray.400" fontStyle="italic">
          {notDefinedText}
        </Text>
      );
    }
    return <Text as="span" color="gray.700">{value}</Text>;
  }

  if (rows === 1) {
    return (
      <Input
        {...field}
        placeholder={placeholder}
        size="sm"
        isInvalid={!!error}
      />
    );
  }

  return (
    <Textarea
      {...field}
      placeholder={placeholder}
      rows={rows}
      size="sm"
      isInvalid={!!error}
      resize="none"
    />
  );
}








